import { getGlobalLookup } from "@faire/web/common/globals/lookup";
import { ENABLE_EVENTS_BATCHING_221102 } from "@faire/web-api/indigofair/settings/ENABLE_EVENTS_BATCHING_221102";
import { EVENTS_BATCHING_LATENCY_AB_EXPERIMENT_240208 } from "@faire/web-api/indigofair/settings/EVENTS_BATCHING_LATENCY_AB_EXPERIMENT_240208";

import {
  getSettingValueAndAssign,
  getSettingValueWithoutAssignment,
} from "./__internal__/getSetting";

const getSettingEnableEventsBatchingKillSwitch = (): boolean => {
  return getSettingValueWithoutAssignment(ENABLE_EVENTS_BATCHING_221102, false);
};

const getSettingEventsBatchingLatencyAbExperiment = (): boolean => {
  return getSettingValueAndAssign(
    EVENTS_BATCHING_LATENCY_AB_EXPERIMENT_240208,
    false
  );
};

export const getSettingEnableEventsBatching = (): boolean => {
  return (
    getSettingEnableEventsBatchingKillSwitch() ||
    (isLoggedInRetailer() && getSettingEventsBatchingLatencyAbExperiment())
  );
};

const isLoggedInRetailer = () => {
  return (
    !!getGlobalLookup()("user") &&
    !!getGlobalLookup()("retailer") &&
    !getGlobalLookup()("editingAsBrandToken")
  );
};
